import amplitude from 'amplitude-js'
import { userPropertyFetch } from './analyticsRequest'
const ampInst = amplitude.getInstance()
ampInst.init(process.env.REACT_APP_AMPLITUDE_API_KEY)
// ampInst.setUserId(window.id)

function ampEvent(event) {
	ampInst.logEvent(event)
}
function ampEventWithEventProperty(event, props) {
	ampInst.logEvent(event, props)
}
function ampSetUserProperty(key, value, user_id) {
	if (key === 'user_id') {
		window.id = value
		ampInst.setUserId(value)
	} else {
		const identify = new amplitude.Identify().set(key, value)
		ampInst.identify(identify)

		if (user_id && value) {
			userPropertyFetch({ [key]: value }, user_id)
		}
	}
}
export { ampEvent, ampEventWithEventProperty, ampSetUserProperty }
